module.exports = __webpack_public_path__ + "static/media/FooterLogo.e3c19a44.svg";